module.exports = __webpack_public_path__ + "img/features-2.c22a35ed.png";